export interface FAQ {
  id: number;
  question: string;
  answer: string;
  category: string;
}

export interface InternationalNumber {
  country: string;
  countryCode: string;
  phoneNumber: string;
}

export interface ContactInfo {
  mainHotline: string;
  supportHours: string;
  internationalNumbers: InternationalNumber[];
  email: string;
  emailResponseTime: string;
  address: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
  };
}

export const getFAQs = async (): Promise<{
  success: boolean;
  data?: FAQ[];
  error?: { message: string } | null;
}> => {
  try {
    // Dynamic import to avoid circular dependency
    const httpClient = (await import('../httpClient')).default;

    const response = await httpClient.get<{ success: boolean; faqs: FAQ[] }>('/support/faqs');

    return {
      success: true,
      data: response.faqs || [],
      error: null
    };
  } catch (error: any) {
    return {
      success: false,
      error: { message: error?.message ?? 'Failed to fetch FAQs' }
    };
  }
};

export const getContactInfo = async (): Promise<{
  success: boolean;
  data?: ContactInfo;
  error?: { message: string } | null;
}> => {
  try {
    // Dynamic import to avoid circular dependency
    const httpClient = (await import('../httpClient')).default;

    const response = await httpClient.get<{ success: boolean; contactInfo: any }>(
      '/support/contact-info'
    );

    // Transform backend response to frontend format
    const contactInfo: ContactInfo = {
      mainHotline: response.contactInfo.phone || '+1 (555) 123-4567',
      supportHours: response.contactInfo.hours || '24/7',
      internationalNumbers: [],
      email: response.contactInfo.email || 'support@magnetix.com',
      emailResponseTime: 'Response within 2 hours',
      address: {
        street: response.contactInfo.address?.split(',')[0] || '123 Learning Street',
        city: 'Education City',
        state: 'EC',
        zipCode: '12345',
        country: 'United States',
      },
    };

    return {
      success: true,
      data: contactInfo,
      error: null
    };
  } catch (error: any) {
    return {
      success: false,
      error: { message: error?.message ?? 'Failed to fetch contact information' }
    };
  }
};
